module.exports = __webpack_public_path__ + "img/2.eb5aaffa.png";